// extracted by mini-css-extract-plugin
module.exports = {"section":"Banner_section__6gKPL"};